import { Modal } from '@/components/ui'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { Event } from '@/types/events'

interface ArchiveConfirmModalProps {
  visible: boolean
  event: Event | null
  onConfirm: () => void
  onCancel: () => void
  loading: boolean
}

export function ArchiveConfirmModal({
  visible,
  event,
  onConfirm,
  onCancel,
  loading,
}: ArchiveConfirmModalProps) {
  return (
    <Modal
      title="Archive Event"
      open={visible}
      onOk={onConfirm}
      onCancel={onCancel}
      okText="Archive"
      cancelText="Cancel"
      okButtonProps={{
        danger: false,
        loading,
      }}
    >
      <div className="flex items-center mb-4">
        <ExclamationCircleOutlined className="text-orange-500 text-xl mr-3" />
        <span>Are you sure you want to archive this event?</span>
      </div>
      {event && (
        <div className="bg-gray-50 p-3 rounded">
          <p className="mb-1">
            <strong>Name:</strong> {event.name}
          </p>
          <p className="mb-1">
            <strong>Client:</strong> {event.client_name}
          </p>
          <p className="mb-0">
            <strong>Status:</strong> {event.status}
          </p>
        </div>
      )}
      <p className="mt-4 text-gray-500">
        The event will be moved to archived status and can be restored later if needed.
      </p>
    </Modal>
  )
}

